import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-phone-landscape",
  "use": "icon-phone-landscape-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" class=\"bi bi-phone-landscape\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-phone-landscape\">\r\n  <path fill-rule=\"evenodd\" d=\"M1 4.5v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1zm-1 6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v6z\" />\r\n  <path fill-rule=\"evenodd\" d=\"M14 7.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/phone-landscape.svg
// module id = 88Pc
// module chunks = 60